import { isEqual } from "lodash";
import { useState, useCallback, useMemo } from "react";

// import { getLocalStorageValue } from "src/utils/local-storage-utils";

import { DayQuickFilter } from "../interfaces";

const useChangeDays = (lsIdentifier?: string) => {
  const [quickFilter, setQuickFilter] = useState<DayQuickFilter>({
    days: {
      selectedDays:
        //  getLocalStorageValue(lsIdentifier ?? "QF_DAYS")?.selectedDays ??
        [],
    },
  });

  const selectedDays = useMemo(() => quickFilter.days.selectedDays, [quickFilter.days.selectedDays]);

  const handleChangeQuickFilter = useCallback(
    (filter: keyof DayQuickFilter, value: DayQuickFilter["days"]) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));

      // localStorage.setItem(lsIdentifier ?? "QF_DAYS", JSON.stringify(value));
    },
    [quickFilter]
  );

  return {
    daysQuickFilter: quickFilter,
    setDaysQuickFilter: handleChangeQuickFilter,
    selectedDays,
  };
};

export default useChangeDays;
